import React from "react";
import logo from "../Assets/footer-logo.png";
import "../Css/Footer.css";
import { AiOutlineLinkedin, AiOutlinePinterest } from "react-icons/ai";
import { IoLogoFacebook } from "react-icons/io";
import { TiSocialInstagram } from "react-icons/ti";
import { Link, NavLink } from "react-router-dom";

const Footer = () => {
  const data = {
    label: "Locations",
    sub: [
      {
        label: "India",
        link: "/certified-diamonds-india",
      },
      {
        label: "Hong Kong",
        link: "/best-natural-diamond-dealer-hong-kong",
      },
      {
        label: "United State America",
        link: "/best-diamond-dealer-america",
      },
      {
        label: "United Kingdom",
        link: "/best-diamond-dealer-united-kingdom",
      },
      {
        label: "Europe",
        link: "/best-diamond-dealer-europe",
      },
      {
        label: "Australia",
        link: "/best-diamond-dealer-australia",
      },
      {
        label: "Dubai",
        link: "/luxury-diamonds-dubai",
      },
      {
        label: "Malaysia",
        link: "/diamond-dealer-malaysia",
      },
      {
        label: "Singapore",
        link: "/best-diamonds-singapore",
      },
      {
        label: "Thailand",
        link: "/best-diamond-dealer-thailand",
      },
    ],
  };
  return (
    <>
      <section className="footer-sec py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <NavLink to="/">
                <img className="footer-img" src={logo} alt="" />
              </NavLink>
              <div>
                <p className="lg-screen-footer-para">
                  We believe in Transparency, Commitment & Support to the best
                  level of client satisfaction. Over the years, we have built
                  respect and trust in the industry is by honest and determined
                  efforts of Mr. Sevantibhai M.Shah who is the founding father
                  of the company
                </p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="footerLinks">
                <h5> Usefull Links</h5>
                <ul className="footer-usefull-link-ul p-0 m-0">
                  <Link to="/">
                    <li className="footer-usefull-link-ol"> HOME</li>
                  </Link>
                  <Link to="/best-diamonds-collection">
                    <li className="footer-usefull-link-ol"> About </li>
                  </Link>

                  <Link to="/natural-diamonds">
                    <li className="footer-usefull-link-ol"> Education</li>
                  </Link>
                  <Link to="/best-diamond-supplier">
                    <li className="footer-usefull-link-ol"> Blog</li>
                  </Link>
                  <NavLink to="/best-diamond-exhibition">
                    <li className="footer-usefull-link-ol"> Exhibitions</li>
                  </NavLink>
                  <NavLink to="/calibrated-diamonds">
                    <li className="footer-usefull-link-ol"> faq</li>
                  </NavLink>

                  <NavLink to="/terms-&-conditions">
                    <li className="footer-usefull-link-ol">
                      Terms & Conditions
                    </li>
                  </NavLink>
                </ul>
              </div>
            </div>
            <div className="col-md-2">
              <div className="footerLinks">
                <h5>Global Reach</h5>
                <div className="row">
                    <div className="col-12">
                      <NavLink to="/certified-diamonds-india">India</NavLink>
                    </div>
                    <div className="col-12">
                      <NavLink to="/best-natural-diamond-dealer-hong-kong">Hong Kong</NavLink>
                    </div>
                    <div className="col-12">
                      <NavLink to="/best-diamond-dealer-america">USA</NavLink>
                    </div>
                    <div className="col-12">
                      <NavLink to="/luxury-diamonds-dubai">Dubai</NavLink>
                    </div>
                    <div className="col-12">
                      <NavLink to="/diamond-dealer-malaysia">Malaysia</NavLink>
                    </div>
                    <div className="col-12">
                      <NavLink to="/best-diamonds-singapore">Singapore</NavLink>
                    </div>
                    <div className="col-12">
                      <NavLink to="/best-diamond-dealer-thailand">Thailand</NavLink>
                    </div>
                </div>
              </div>
            </div>
            <div className="col-md-2">
              <div className="footerLinks">
               <div className="footerLinks-add">
               <div className="row">
                    <div className="col-12">
                      <NavLink to="/best-diamond-dealer-united-kingdom">United Kingdom</NavLink>
                    </div>
                    <div className="col-12">
                      <NavLink to="/best-diamond-dealer-europe">Europe</NavLink>
                    </div>
                    <div className="col-12">
                      <NavLink to="/best-diamond-dealer-australia">Australia</NavLink>
                    </div>
                </div>
               </div>
              </div>
            </div>
            <div className="col-md-3">
              <h5> Contact us</h5>
              <div className="footer-contact-us-details footer-contact-us-details-fs mb-2">
                <NavLink to="mailto: websales@sejalgems.in">
                  websales@sejalgems.in
                </NavLink>
                <NavLink to="tel:+9102240431111">+91 (0) 022 4043 1111</NavLink>
                <NavLink to="tel:+919326713857">+91 93267-13857</NavLink>
              </div>
              <div>
                <p className="footer-contact-us-details-fs">
                  C- East 4011, BDB, opposite NABARD, G Block, Bandra Kurla
                  Complex, Bandra East, Mumbai, Maharashtra 400051
                </p>
              </div>
              <div className="footer-social-media-icon">
                <span>
                  <NavLink
                    to="https://www.linkedin.com/company/sejal-exports-india/mycompany/"
                    target="_blank"
                  >
                    <AiOutlineLinkedin />
                  </NavLink>
                </span>
                <span>
                  <NavLink
                    to="https://in.pinterest.com/natural_diamondss/"
                    target="_blank"
                  >
                    <AiOutlinePinterest />
                  </NavLink>
                </span>
                <span>
                  <NavLink
                    to="https://www.instagram.com/naturalmeleediamonds/"
                    target="_blank"
                  >
                    <TiSocialInstagram />
                  </NavLink>
                </span>
                <span>
                  <NavLink
                    to="https://www.facebook.com/meleediamondsupplier "
                    target="_blank"
                  >
                    <IoLogoFacebook />
                  </NavLink>
                </span>
              </div>
            </div>
          </div>
          <h6 className="text-center mt-5">
            © {new Date().getFullYear()} Sejal Exports India. All Rights
            Reserved. | Small Things Matter
            {/* <span className="text-center text-lg-left">
              Developed By Shree Krishna Digital
            </span> */}
          </h6>
        </div>
      </section>
      {/* <SeoLinks /> */}
    </>
  );
};

export default Footer;
